var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z",
    stroke: "#00C271",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18C12.6213 18 13.125 17.4963 13.125 16.875C13.125 16.2537 12.6213 15.75 12 15.75C11.3787 15.75 10.875 16.2537 10.875 16.875C10.875 17.4963 11.3787 18 12 18Z",
    fill: "#00C271"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.5005V12.7505C12.5192 12.7505 13.0267 12.5965 13.4584 12.3081C13.8901 12.0197 14.2265 11.6097 14.4252 11.13C14.6239 10.6504 14.6758 10.1226 14.5746 9.61338C14.4733 9.10418 14.2233 8.63645 13.8562 8.26933C13.489 7.90222 13.0213 7.65221 12.5121 7.55093C12.0029 7.44964 11.4751 7.50163 10.9955 7.70031C10.5158 7.89899 10.1058 8.23544 9.81739 8.66712C9.52895 9.0988 9.375 9.60631 9.375 10.1255",
    stroke: "#00C271",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIc);
export default __webpack_public_path__ + "static/media/question_ic.951c942aad2ad4482d21e29ca79d4ea7.svg";
export { ForwardRef as ReactComponent };